import React from 'react';

export default function StatsCard({ label, value }) {
  return (
    <div className="bg-white border border-sand-200 rounded-lg p-4 shadow-card">
      <p className="font-heading text-2xl font-semibold text-terra-400">{value}</p>
      <p className="text-sm text-ink-400 mt-0.5">{label}</p>
    </div>
  );
}
